import { ProjectChildItemTypes } from '../../types';
import { PropertiesResponseTypes } from '../../types/response';

export const convertProjectChildItemResponse = (
  item: PropertiesResponseTypes
): ProjectChildItemTypes => {
  if (!item || !item.projectChildItem) return null;

  return {
    code: item.code,
    price: item.price,
    status: item.status,
    statusDescription: item.statusDescription,
    availableStatusTime: item.availableStatusTime,
    projectCode: item.project ? item.project.code : null,
    projectItemCode: item.projectItem ? item.projectItem.code : null,
    floorCode: item.floor ? item.floor.code : null,

    name: item.projectChildItem.name,
    type: item.projectChildItem.type,
    alias: item.projectChildItem.alias,
    direction: item.projectChildItem.direction,
    bedrooms: item.projectChildItem.bedrooms,
    bathrooms: item.projectChildItem.bathrooms,
    positionType: item.projectChildItem.positionType,
    square: item.projectChildItem.square,
    usableSquare: item.projectChildItem.usableSquare,
    avatar: item.projectChildItem.avatar,
    activeSession: item.activeSession
  };
};
